import { render, staticRenderFns } from "./ListaEncuestas.vue?vue&type=template&id=5bdb6c2e"
import script from "./ListaEncuestas.vue?vue&type=script&lang=ts"
export * from "./ListaEncuestas.vue?vue&type=script&lang=ts"
import style0 from "./ListaEncuestas.vue?vue&type=style&index=0&id=5bdb6c2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports